import { Component } from 'react'
import { connect } from 'react-redux'
import { EditButton } from '../../cdl-react-components/components'

class EditButtonWrapper extends Component {
    render() {
        const { user } = this.props
        return user && user.isCDLUser ?
            <EditButton href={this.props.href} /> :
            null
    }
}

const mapStateToProps = ({ data }) => ({ user: data.user })

export default connect(mapStateToProps)(EditButtonWrapper)